import { createContext } from 'react';

export type Severity = 'success' | 'error' | 'warning' | 'info';

interface NotificationContextProps {
  isVisible: boolean;
  showNotification: (message: string, severity: Severity) => void;
  hideNotification: () => void;
  message: string;
  severity: Severity;
}

export const NotificationContext = createContext<NotificationContextProps | undefined>(undefined);
